<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <input
      type="email"
      class="form-control"
      placeholder="Entre com o e-mail"
      v-model="m_fieldAnswer.value"
      :disabled="disabledAttribute"
    />
  </div>
</template>

<script>
  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'EmailField',
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: this.fieldAnswer.value
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    methods: {
      isValid () {
        if (
          (this.field.required && !this.m_fieldAnswer.value) ||
          (this.m_fieldAnswer.value && !this.isEmailValid())
        ) {
          this.m_error = true
          return false
        }

        this.m_error = null
        return true
      },
      isEmailValid () {
        let filter = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
        return filter.test(this.m_fieldAnswer.value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailField.vue?7f806bc2